<div class="page-title-area item-bg2">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a href="/" i18n>Home</a></li>
                <li i18n>Projects</li>
                <li></li>
            </ul>
            <h2 i18n>List of Projects</h2>
        </div>
    </div>
</div>

<div class="blog-area ptb-100" [class.dark-blog-area]="themeService.isDark()">
    <div class="container">
        <div class="row pb-5">
            <h3 i18n>All Projects</h3>
            <div class="woocommerce-topbar">
                <div class="row align-items-center">
                    <div class="col-lg-12 col-md-12">
                        <div class="topbar-ordering-and-search">
                            <div class="row align-items-center">
                                <form [formGroup]="filter_form" (submit)="applyFilter()">
                                    <div class="row">
                                        <div class="col-lg-12 col-md-12">
                                            <div class="billing-details">
                                                <div class="row">
                                                    
                                                    <div class="col-lg-6 col-md-6">
                                                        <div class="form-group">
                                                            <label i18n>Project Type</label>
                                                            <div class="select-box">
                                                                <select formControlName="category"
                                                                    class="form-select">
                                                                    <option *ngFor="let prt of project_types"
                                                                        [value]="prt.id">{{prt.category_name}}</option>
                                                                </select>

                                                            </div>
                                                        </div>
                                                    </div>
                                                    

                                                    <div class="col-lg-6 pt-3">
                                                        <div class="form-group">
                                                            <label></label>
                                                            <div>
                                                                <button type="submit" value="Filter" class="default-btn">
                                                                    <i class='bx bx-filter-alt icon-arrow before'></i><span
                                                                        class="label" i18n>Filter</span><i
                                                                        class="bx bx-filter-alt icon-arrow after"></i>
                                                                </button>
                                                                &nbsp; &nbsp;
                                                                <a (click)="resetFilter()" class="back-btn">
                                                                    <i class='bx bx-reset icon-arrow before'></i><span
                                                                        class="label" i18n>Reset</span><i
                                                                        class="bx bx-reset icon-arrow after"></i>
                                                                </a>

                                                            </div>
                                                            
                                                        </div>

                                                    </div>


                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="row" *ngFor="let project of projects">
                <div class="col-lg-12 col-md-12">
                    <div class="single-courses-list-box mb-30">
                        <div class="box-item">
                            <div class="courses-image" >
                                <div class="image" [style]="'background-image: url('+imageUrl + project.picture+')'">
                                    <a routerLink="/projects/{{project.id}}" class="link-btn"></a>
                                    <div class="courses-tag">
                                        <a routerLink="" class="d-block">{{project.project_category.category_name}}</a>
                                    </div>
                                </div>
                            </div>
                            <div class="courses-desc">
                                <div class="courses-content">
                                    <div class="course-author d-flex align-items-center">
                                        <span>{{project.location}}</span>
                                    </div>
                                    <h3><a routerLink="/projects/{{project.id}}" class="d-inline-block">{{project.name}}</a></h3>
                                    
                                    <p>{{project.achievements}}</p>
                                </div>
                                <div class="courses-box-footer">
                                    <ul>
                                        <li class="students-number">
                                            <span i18n>From</span>: <i class='bx bx-calendar'></i> {{project.start_date|date:'longDate'}}
                                        </li>
                                        <li class="courses-lesson">
                                            <span i18n>To</span>: <i class='bx bx-calendar'></i> {{project.end_date|date:"longDate"}}
                                        </li>
                                        
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div class="col-lg-12 col-md-12 col-sm-12">
                <app-pagination [currentPage]="currentPage" [itemsPerPage]="itemsPerPage" [totalItems]="totalItems"
                    (pageChanged)="onPageChange($event)"></app-pagination>
            </div>
        </div>
    </div>
</div>